import { ENVIRONMENT } from "../helper/getEnvVariables";

export const KAKI_MAKAN_PLAYLIST_ID = import.meta.env
  .VITE_KAKI_MAKAN_PLAYLIST_ID as string;
export const KAKI_MAKAN_AUTOPLAY_PLAYER_ID = import.meta.env
  .VITE_KAKI_MAKAN_AUTOPLAY_PLAYER_ID as string;

export const KakiMakanSubSectionListMapping: { [key: string]: string } = {
  "Makanan Asia": "kaki-makan_makanan-asia",
  "Makanan Barat": "kaki-makan_makanan-barat",
  Fusion: "kaki-makan_fusion",
  "Pusat Penjaja & Kedai Kopi": "kaki-makan_pusat-penjaja-kedai-kopi",
  Bufet: "kaki-makan_bufet",
  "Pencuci Mulut & Pastri": "kaki-makan_pencuci-mulut-pastri",
  "Minuman & Kafe": "kaki-makan_minuman-kafe",
  "Perniagaan Dari Rumah": "kaki-makan_perniagaan-dari-rumah",
  "Pilihan Kaki Makan": "kaki-makan_pilihan-kaki-makan",
};

export const KakiMakanSectionAndSubSectionsUniqueNames = [
  "kaki-makan",
  "kaki-makan_makanan-asia",
  "kaki-makan_makanan-barat",
  "kaki-makan_fusion",
  "kaki-makan_pusat-penjaja-kedai-kopi",
  "kaki-makan_bufet",
  "kaki-makan_pencuci-mulut-pastri",
  "kaki-makan_minuman-kafe",
  "kaki-makan_perniagaan-dari-rumah",
  "kaki-makan_pilihan-kaki-makan",
];

export const KAKI_MAKAN_LANDING_PAGE = "kaki-makan";
export const KAKI_MAKAN_ADS_SECTION = "kaki-makan";

export const RESTAURANT_SEARCH_PLACEHOLDER_COPY = "Kata Carian";
export const READ_ARTICLE_COPY = "Baca laporan";
export const VIEW_MORE_COPY = "Laporan Lain";
export const VIEW_LESS_COPY = "Kurang";
export const LOAD_MORE_COPY = "Lagi";
export const ADDRESS_HEADER_COPY = "Alamat";
export const OPERATING_HOURS_COPY = "Waktu Operasi";

export const KAKI_MAKAN_REF_CODE_READ_ARTICLE = "?ref=kaki-makan-article";
export const KAKI_MAKAN_REF_CODE_MENU = "?ref=kaki-makan-menu";
export const KAKI_MAKAN_EVENT_CATEGORY = "kaki makan";

export const MAX_SEARCH_LENGTH = 100;

export const BH_HOME_BANNERS_KAKI_MAKAN: string =
  ENVIRONMENT === "prd" ? "1422" : "1871";

export const BH_BANNERS_KAKI_MAKAN: string =
  ENVIRONMENT === "prd" ? "1423" : "1873";
